
















































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import AutoCreateForm from '@/components/form/AutoCreateForm.vue';
import ListDisplay from '@/components/common/modules/ListDisplay.vue';
import InputArea from '@/components/common/modules/InputArea.vue';
import RateTabPanel from '@/components/common/modules/RateTabPanel.vue';
import Button from '@/components/common/elements/Button.vue';
import CreateTaxSummary from '@/components/estimate/CreateTaxSummary.vue';
import RateTable from '@/components/common/modules/tabs/estimate/RateTable.vue';

//import InputNoVModel from '@/components/common/elements/InputNoVModel.vue';
//import SelectNoVModel from '@/components/common/elements/SelectNoVModel.vue'

@Component({
  components: {
    AutoCreateForm,
    ListDisplay,
    InputArea,
    RateTabPanel,
    Button,
    CreateTaxSummary,
    RateTable
  }
})
export default class EstimateInformation extends Vue {
  private isEager = true;

  @Prop({ default: () => ({}) })
  private item: any;
  @Prop({ default: () => ({}) })
  private configurationTableData: any;

  //  税率毎サマリパネル
  private taxSummaryColumns: Array<{ [k: string]: string | number }> = [
    { value: 'name', text: '課税区分', order: 0, width: '15%' },
    { value: 'tax_rate', text: '税率（％）', order: 1, width: '15%' },
    { value: 'amount', text: '金額', order: 2, width: '15%' },
    { value: 'tax', text: '税額', order: 3, width: '15%' },
    { value: 'tax_included_amount', text: '合計', order: 4, width: '15%' }
  ];

  // どのダイアログマスタ定義を参照するか管理
  dialogMasterIndex = '';

  get hasEstimateInformationPanelDatas(){
    return  this.item && this.item.estimateInformationData.estimateDetailInformation.estimateInformationPanel.datas.length >= 5
  }

  get estimateInformationPanelDatas(){
    if(!this.hasEstimateInformationPanelDatas){
      return []
    }
    return  this.item.estimateInformationData.estimateDetailInformation.estimateInformationPanel.datas.slice(0, 5)
  }

  @Emit('tabChildrenEventRelay')
  private catchInputRelay(response: any) {
    response.functionName = 'catchInputRelay';
    return response;
  }

  @Emit('tabChildrenEventRelay')
  private catchTableDataRelay(response: any) {
    response.functionName = 'getdataRelay';
    return response;
  }

  @Emit('tabChildrenEventRelay')
  private catchInputSummaryPanel(response: any) {
    response.functionName = 'catchInputSummaryPanel';
    return response;
  }

  /**
   * 親コンポーネントにテキストフィールドで入力された行のアイテムをオブジェクトで返します
   * @module getData
   * @param inputValue - 入力値
   * @param inputName - 入力フィールド名
   * @param record - アイテム情報
   * @return { inputValue, inputName, itemIndex, record }
   */
  @Emit('tabChildrenEventRelay')
  getdataRelay(response: any) {
    response.functionName = 'getdataRelay';
    return response;
  }

  @Emit('tabChildrenEventRelay')
  private clickItemAdditionButtonRelay(response: any) {
    response.functionName = 'clickItemAdditionButtonRelay';
    return response;
  }

  @Emit('tabChildrenEventRelay')
  private clickDownloadButtonEventRelay(response: any) {
    response.functionName = 'clickDownloadButtonEventRelay';
    return response;
  }

  @Emit('tabChildrenEventRelay')
  private masterSelectEventRelay(response: any) {
    response.functionName = 'masterSelectEventRelay';
    return response;
  }

  @Emit('tabChildrenEventRelay')
  private clickFixedMatterEvent(response: any) {
    const clickFixedMatter: any = []
    clickFixedMatter.functionName = 'clickFixedMatterEvent';
    if (response === true) {
      clickFixedMatter.name = 'clickFixedMatter';
    } else {
      clickFixedMatter.name = response;
    }
    return clickFixedMatter;
  }

  @Emit('tabChildrenEventRelay')
  private clickFractionRoundingEvent(response: any) {
    const clickFractionRounding: any = [];
    clickFractionRounding.functionName = 'clickFractionRoundingEvent';
    if (response === true) {
      clickFractionRounding.name = 'clickFractionRounding';
    } else {
      clickFractionRounding.name = response;
    }
    return clickFractionRounding;
  }

  @Emit('tabChildrenEventRelay')
  private clickUndoFractionRoundingEvent(response: any) {
    const clickUndoFractionRounding: any = [];
    clickUndoFractionRounding.functionName = 'clickUndoFractionRoundingEvent';
    if (response === true) {
      clickUndoFractionRounding.name = 'clickUndoFractionRounding';
    } else {
      clickUndoFractionRounding.name = response;
    }
    return clickUndoFractionRounding;
  }

  @Emit('tabChildrenEventRelay')
  private clickRecalcEvent(response: any) {
    const clickRecalc: any = [];
    clickRecalc.functionName = 'clickRecalcEvent';
    if (response === true) {
      clickRecalc.name = 'clickRecalc';
    } else {
      clickRecalc.name = response;
    }
    return clickRecalc;
  }

  @Emit('clickButton')
  public clickButton(response: any) {
    this.dialogMasterIndex = response.buttonName;
  }
}
